// For full API documentation, including code examples, visit http://wix.to/94BuAAs

import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

$w.onReady(function () {

	if(wixWindow.formFactor === "Mobile"){
        $w("#CloudsGif").show();
    }

});

export function button1_click(event) {
	$w('#ShortForm').changeSlide(1);
}

export function backbutton_click(event) {
	$w('#ShortForm').changeSlide(0); 
}


import {sendEmail, sendEmailWithRecipient} from 'backend/email';

$w.onReady(function () {
  $w("#dataset1").onAfterSave(sendFormData);
});

function sendFormData() {
  const subject = `New Lead from Minimal Homepage ${$w("#firstName").value}`;
  const body = `Here's the details:
    \rEvent Type: ${$w("#eventType").value}
    \rFirst Name: ${$w("#firstName").value}
    \rLName: ${$w("#lastName").value}
    \rEmail Address: ${$w("#email").value}
    \rTelephone: ${$w("#phone").value}
    \rMonth: ${$w("#month").value}
    \rDay: ${$w("#day").value}
	\rYear: ${$w("#year").value}
	\rInquiry Source: ${$w("#dropdown1").value}`;
    
  sendEmail(subject, body)
    .then(response => console.log(response));
}

